import { render } from "./ModuleForm.vue?vue&type=template&id=623c2408&scoped=true"
import script from "./ModuleForm.vue?vue&type=script&lang=js"
export * from "./ModuleForm.vue?vue&type=script&lang=js"

import "./ModuleForm.vue?vue&type=style&index=0&id=623c2408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623c2408"]])

export default __exports__